import http from './http'

class GroupAbc {
  taxByPayer (id) {
    return http.get(`/abc/group_taxes/by_payer/${id}`)
  }

  create (groupTax) {
    return http.post('/abc/group_taxes/', { group_tax: groupTax })
  }

  update (groupTax) {
    return http.put(`/abc/group_taxes/${groupTax.id}`, { group_tax: groupTax })
  }

  delete (id) {
    return http.delete(`/abc/group_taxes/${id}`)
  }
}

export default new GroupAbc()



// WEBPACK FOOTER //
// ./src/services/group_abc.js